export const SET_DEALTS = "setDealts";
export const SET_QUERY_PARAMS = "setQueryParams";
export const CLEAR_DEALTS_STATE = "clearDealtsState";
export const SET_VISIBLECOLUMNS = "setVisibleColumns";
export const SET_DEALT = "setDealt";
export const CLEAR_DEALT = "clearDealt";
